import script from "./ChatPricingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPricingModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatPricingModal.vue?vue&type=style&index=0&id=c4f65e56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4f65e56"]])

export default __exports__